import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useGetPlannedTaskTags } from '@/shared/hooks/task/useGetPlannedTaskTags';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import MultiSelect, { splitItems } from '../multiselect/MultiSelect';
export const PlannedTasksTagsMultiSelect = ({ selectedItems, placeholder, onChange, onFilterBehaviourChanged, filterBehaviour, withFilterBehaviour, }) => {
    const { data } = useGetPlannedTaskTags();
    const taskLabels = data === null || data === void 0 ? void 0 : data.map(x => ({ id: x.id, label: x.name, sort: x.name.toLowerCase() })).sort(dynamicSort('sort'));
    const [selectedLabels, availableLabels] = splitItems(taskLabels, selectedItems, 'id');
    return (_jsx(MultiSelect, { selectedItem: selectedLabels, onItemRemoved: item => onChange(selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.filter(label => label !== item.value.id)), onItemSelected: item => onChange([...(selectedItems !== null && selectedItems !== void 0 ? selectedItems : []), item.id]), items: availableLabels, placeholder: placeholder, onFilterBehaviourChanged: (behaviour) => onFilterBehaviourChanged(behaviour), filterBehaviour: filterBehaviour, withFilterBehaviour: withFilterBehaviour }));
};
export const FilterPlannedTasksTagsMultiSelect = ({ item, setFilter, activeFilters, label, isAlwaysVisible, withFilterBehaviour, enabled, }) => {
    var _a;
    return ({
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(PlannedTasksTagsMultiSelect, { onChange: value => {
                var _a;
                setFilter({
                    [item]: ((_a = value === null || value === void 0 ? void 0 : value.length) !== null && _a !== void 0 ? _a : 0) > 0 ? value : undefined,
                });
            }, selectedItems: activeFilters[item], placeholder: label, withFilterBehaviour: withFilterBehaviour, onFilterBehaviourChanged: filterBehaviour => {
                setFilter({
                    filterBehaviours: {
                        [item]: filterBehaviour,
                    },
                });
            }, filterBehaviour: (_a = activeFilters.filterBehaviours) === null || _a === void 0 ? void 0 : _a[item] })),
    });
};
